import { axiosInstance, parseResult } from "./CommonApi";

export const getModels = async () => parseResult(await axiosInstance.get("/rtu/polling-inverter-model/"));
export const createModel = async (payload) => parseResult(await axiosInstance.post("/rtu/polling-inverter-model/", payload));
export const updateModel = async (id, payload) => parseResult(await axiosInstance.put(`/rtu/polling-inverter-model/${id}/`, payload));
export const deleteModels = async (ids) => parseResult(await axiosInstance.delete("/rtu/polling-inverter-model/", { data: { ids } }));
